export enum ITINERARY_CONTEXT {
    BOOK_NOW,
    MY_GREYHOUND
}



// WEBPACK FOOTER //
// ./src/app/shared/models/enums/context.enum.ts